import React, {useEffect, useState} from 'react';
import {differenceInDays, differenceInHours} from 'date-fns';


import {TimelineProps} from "@mui/lab/Timeline/Timeline";
import {Step, StepIcon, StepLabel, Stepper} from "@mui/material";
import Typography from "@mui/material/Typography";


import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import ErrorIcon from '@mui/icons-material/Error';

import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

import {HttpOrders} from "../../pages/orders/api/HttpOrders";
import {OrderHistory, OrderHistoryFields} from "../../pages/orders/types/dto";
import OrderStatusChip from "../../pages/orders/components/OrderStatusChip";
import {dateFormatter} from "../../utils/formatters";
import {OrderStatusTypes} from "../../pages/orders/types/enum";
import {OrderFields} from "../../pages/orders/types/fields";
import {getOrderStatusColor} from "../../pages/orders/types/typification";
import Box from "@mui/material/Box";
import {styled} from "@mui/system";

const StyledStepper = styled(Stepper)({
    justifyContent: 'flex-start', // This aligns the items to the left
});

interface HorizontalTimelineProps extends TimelineProps {
    orderId: number
}

function OrderStatusTimeline({orderId}: HorizontalTimelineProps) {
    const [history, setHistory] = useState<OrderHistory[]>([])

    useEffect(() => {
        HttpOrders.getOrderHistory(orderId)
            .then(setHistory)
    }, [orderId])


    return (
        <Box display="flex" alignItems="flex-start" flexDirection="column">
            <Typography variant="h6" gutterBottom>
                Historial de la entrega
            </Typography>
            <StyledStepper alternativeLabel sx={{width: 1}}>
                {
                    history.map((item, index) => {
                            // const previousDate = index !== 0 ? parseISO(history[index - 1].fecha) : null;
                            // const currentDate = parseISO(item.fecha);
                            // const daysDifference = previousDate ? differenceInDays(currentDate, previousDate) : null;
                            const dayDifference = index !== (history.length - 1) ? differenceInDays(new Date(history[index + 1].fecha), new Date(item.fecha)) : 0
                            const hourDifference = index !== (history.length - 1) ? differenceInHours(new Date(history[index + 1].fecha), new Date(item.fecha)) : 0

                            return (
                                <Step key={index}>
                                    <StepLabel
                                        StepIconComponent={props => {
                                            const color = getOrderStatusColor(item[OrderFields.StatusCode]);

                                            switch (item[OrderFields.StatusCode]) {
                                                case OrderStatusTypes.PENDING:
                                                    return <HourglassEmptyIcon style={{color: color}}/>
                                                case OrderStatusTypes.DELAYED:
                                                    return <PauseCircleFilledIcon style={{color: color}}/>
                                                case OrderStatusTypes.CANCELLED:
                                                    return <ErrorIcon style={{color: color}}/>
                                                case OrderStatusTypes.DELIVERED:
                                                    return <CheckCircleOutlineIcon style={{color: color}}/>
                                                default:
                                                    return <StepIcon {...props} />
                                            }
                                        }}
                                    >
                                        <OrderStatusChip orderOption={item}/>
                                        {/*<Typography>Step {index + 1}</Typography>*/}
                                        <Typography variant="caption" display="block">
                                            {dateFormatter.toShortDate(item[OrderHistoryFields.Date])}
                                        </Typography>
                                        {index < history.length && (
                                            <Typography variant="caption"
                                                        style={{
                                                            position: 'relative',
                                                            left: '50%',
                                                            top: '-50px',
                                                            transform: 'translateX(-50%)'
                                                        }}>
                                                {index !== (history.length - 1) && `${dayDifference < 1 ? hourDifference + ' horas' : dayDifference + ' días'}`}
                                            </Typography>
                                        )}
                                    </StepLabel>
                                </Step>
                            )
                        }
                    )

                }
            </StyledStepper>
        </Box>

    );
}

export default OrderStatusTimeline;